import { AfterContentInit, Component, ElementRef, Inject, Input, OnChanges } from '@angular/core';
import { Tile } from '../tile/tile';
import { WindowScrollerService } from '../services/window-scroller.service';

@Component({
  selector: 'app-tiles',
  templateUrl: './tiles.component.html',
  styleUrls: ['./tiles.component.scss'],
})
export class TilesComponent implements AfterContentInit, OnChanges {
  @Input() tiles: Tile[];
  @Input() parentRoute: string;

  constructor(
    public elementRef: ElementRef,
    @Inject('WindowScrollerService') private windowScrollerService: WindowScrollerService
  ) {}

  ngOnChanges(): void {
    this.scrollIntoView();
  }

  scrollIntoView() {
    setTimeout(() => {
      this.windowScrollerService.scrollIntoView(this.elementRef.nativeElement);
    }, 100);
  }

  ngAfterContentInit(): void {
    this.scrollIntoView();
  }
}
